import React from 'react';
import { toast } from 'react-toastify';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import {
  Button,
  Form,
  Input,
  Divider,
  Icon,
  Message,
  Transition,
} from 'semantic-ui-react';
import { AUTH_TOKEN, GUEST_TOKEN } from 'config/constants';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../messages';
import AuthUserFragment from '../graphql/userFragment.gql';
import WRAPPER_QUERY from 'containers/LegacyCartPage/graphql/ordersWrapperQuery.gql';
import CART_QUERY from 'containers/LegacyCartPage/graphql/legacyCartQuery.gql';
import FbLoginButton from 'components/FbLoginButton';
import GoogleLoginButton from 'components/GoogleLoginButton';

const IS_TOKEN = gql`
  query IsToken {
    isToken
  }
`;
const IS_LOGGED_IN = gql`
  query IsLoggedIn {
    isLoggedIn
  }
`;

class Login extends React.Component {
  state = {
    loading: false,
    email: '',
    password: '',
    formErrors: [],
  };

  componentDidMount() {
    this.emailInput.focus();
  }

  updateCachedToken = (proxy, { data: { login } }) => {
    window.isLoggedIn = true;

    localStorage.setItem(AUTH_TOKEN, login.token);
    localStorage.removeItem(GUEST_TOKEN);

    window.google.accounts.id.cancel();

    // Write our data back to the cache.
    proxy.writeQuery({
      query: IS_TOKEN,
      data: {
        isToken: !!login.token,
      },
    });
    proxy.writeQuery({
      query: IS_LOGGED_IN,
      data: {
        isLoggedIn: !!login.token,
      },
    });
  };

  _confirm = async () => {
    this.setState({ loading: true });

    const { email, password } = this.state;

    const result = await this.props.getUserToken({
      variables: {
        email,
        password,
      },
      update: this.updateCachedToken,
      refetchQueries: () => [
        { query: USER_QUERY },
        { query: CART_QUERY },
        { query: WRAPPER_QUERY },
      ],
      awaitRefetchQueries: true,
      errorPolicy: 'all',
    });

    // eslint-disable-next-line no-unused-vars
    let wrongUserNameOrPassword;
    if (result === undefined) {
      wrongUserNameOrPassword = toast.info(
        <FormattedMessage {...messages.invalidInput} />,
        {
          autoClose: 5000,
          onClose: () => {
            wrongUserNameOrPassword = null;
          },
        }
      );
      this.setState({ loading: false });
    } else {
      const user = result.data.login;

      if (result.errors && result.errors.length) {
        this.setState({ formErrors: [result.errors[0].message] });
      }

      if (user) {
        if (this.props.handleClose) {
          this.props.handleClose();
        }

        if (this.props.redirectTo) {
          if (this.props.redirectTo !== 'nothing') {
            this.props.history.push(this.props.redirectTo);
            return;
          }
        } else {
          // this.props.history.push('/');
        }
        return;
      }
      this.setState({ loading: false });
    }
  };

  render() {
    if (this.props.visible === false) {
      return null;
    }

    return (
      <div>
        <Form loading={this.state.loading}>
          <Divider horizontal>
            <FormattedMessage {...messages.loginHeader} />
          </Divider>

          <Transition
            visible={this.state.formErrors.length > 0}
            animation="scale"
          >
            <Message
              error
              list={this.state.formErrors}
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            />
          </Transition>

          <GoogleLoginButton />
          <FbLoginButton />

          <Divider horizontal>
            <FormattedMessage {...messages.or} />
          </Divider>

          <Form.Field>
            <label
              className="pullLeft"
              htmlFor="presentation"
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            >
              <FormattedMessage {...messages.email} />
            </label>
            <Input
              ref={(e) => {
                this.emailInput = e;
              }}
              type="email"
              placeholder="example@email.com"
              value={this.state.email}
              onChange={(e) => this.setState({ email: e.target.value })}
              input={
                <input
                  style={{
                    textAlign:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                    direction:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                  }}
                />
              }
            />
          </Form.Field>

          <Form.Field>
            <label
              className="pullLeft"
              htmlFor="presentation"
              style={{
                textAlign: this.props.intl.locale === 'ar' ? 'right' : 'left',
                direction: this.props.intl.locale === 'ar' ? 'right' : 'left',
              }}
            >
              <FormattedMessage {...messages.password} />
            </label>
            <Input
              type="password"
              placeholder={this.props.intl.formatMessage({
                ...messages.passwordPlaceHolder,
              })}
              value={this.state.password}
              onChange={(e) => this.setState({ password: e.target.value })}
              input={
                <input
                  style={{
                    textAlign:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                    direction:
                      this.props.intl.locale === 'ar' ? 'right' : 'left',
                  }}
                />
              }
            />
          </Form.Field>

          <Form.Field>
            <Button color="blue" fluid onClick={() => this._confirm()}>
              <Icon name="sign in" />
              <FormattedMessage {...messages.loginButtonText} />
            </Button>
          </Form.Field>

          <Form.Field>
            <Button
              as="a"
              basic
              fluid
              onClick={(e) => this.props.goTo('forgetpass', e)}
            >
              <FormattedMessage {...messages.forgotPassword} />
            </Button>
          </Form.Field>

          <Divider section horizontal>
            <FormattedMessage {...messages.newUser} />
          </Divider>

          <Form.Field>
            <Button
              as="a"
              color="black"
              fluid
              onClick={(e) => this.props.goTo('register', e)}
            >
              <FormattedMessage {...messages.createAccountButtonText} />
            </Button>
          </Form.Field>
        </Form>
      </div>
    );
  }
}

const USER_QUERY = gql`
  query User {
    user {
      ...AuthUserFragment
    }
  }
  ${AuthUserFragment}
`;

const LOGIN_MUTATION = gql`
  mutation getUserToken($email: String!, $password: String!) {
    login(auth: { email: $email, password: $password }) {
      ...AuthUserFragment
    }
  }
  ${AuthUserFragment}
`;

export default compose(
  injectIntl,
  withRouter,
  graphql(USER_QUERY, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { user } }) => ({ user }),
  }),
  graphql(LOGIN_MUTATION, {
    name: 'getUserToken',
  })
)(Login);



// WEBPACK FOOTER //
// ./app/containers/Auth/Login/index.js